import { chakra } from '@plurall/elo-v3';

import { performanceComparisonChartRecipe } from './PerformanceComparisonCard.recipe';

export const PerformanceComparisonChartFactory = chakra('div', performanceComparisonChartRecipe);
